import React, { RefObject, useRef } from 'react'

import NumberInput from '../NumberInput'

export interface IRadioItemProps {
  id?: string
  name?: string
  label: string
  checked?: boolean
  rf?: string
  rfNumber?: string
  value: number | string | boolean
  unit?: string
  defaultValue?: number
  userTracking?: any
  min?: number
  max?: number
  numberValue: number
  format?: (value: string) => void
  onNumberValueChange?: (value: number) => void
  onChange?: (value: number | string | boolean) => void
  className?: string
}

const RADIO_BASE_CLASS = 'cs-radio'
const RADIO_ACTIVE_CLASS = 'cs-radio active'

const RadioTabNumberItem = ({
  checked,
  id,
  label,
  name,
  rf,
  rfNumber,
  value,
  onChange,
  unit,
  defaultValue,
  userTracking,
  min,
  max,
  numberValue,
  onNumberValueChange,
  format,
  className = ''
}: IRadioItemProps) => {
  const radioRef: RefObject<HTMLInputElement> = useRef()

  const handleChange = (newValue: number) => onNumberValueChange(newValue)

  const handleTabChange = () => {
    if (radioRef.current.checked === false) {
      radioRef.current.checked = true
      onChange(value)
    }
  }

  return (
    <li role='presentation' data-testid={rf} onClick={handleTabChange}>
      <input
        id={id}
        type='radio'
        className={'csas-filled'}
        name={name}
        value={value.toString()}
        defaultChecked={checked}
        onChange={handleTabChange}
        ref={radioRef}
      />
      <label
        htmlFor={id}
        className={checked ? className + ' ' + RADIO_ACTIVE_CLASS : className + ' ' + RADIO_BASE_CLASS}
      >
        {label}&nbsp;
        <div>
          <NumberInput
            value={numberValue}
            onChangeComplete={handleChange}
            defaultValue={defaultValue}
            userTracking={userTracking}
            inputClass='csas-input-tel csas-filled input-text-color input-max-width'
            min={min}
            max={max}
            rf={rfNumber}
            format={format}
          />
        </div>
        <span className='tab-item-unit'>{unit}</span>
      </label>
    </li>
  )
}

export default RadioTabNumberItem
